import React, { useEffect, useState } from "react";
import "./AfterImageQuestionnaire.css";
import { DEBUG_MODE } from "../../config/appConfig";
import Button from "@mui/material/Button";
import { getDebugAfterImageQuestionnaireData } from "../../utils/debugPrefill";

const AfterImageQuestionnaire = ({
  handleFormSubmission,
  isVisualExplainationAvailable,
  isTextualExplanationAvailable,
  debugPrefill = false,
}) => {
  // Log the props to verify they are being passed correctly
  console.log("AfterImageQuestionnaire props:", {
    isVisualExplainationAvailable,
    isTextualExplanationAvailable,
  });

  const [formData, setFormData] = useState({
    captionQuality: "",
  });

  useEffect(() => {
    if (debugPrefill) {
      setFormData(getDebugAfterImageQuestionnaireData());
    }
  }, [debugPrefill]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // alert("Thank you for your feedback!");
    handleFormSubmission(formData);
  };

  const fillDebugData = () => {
    setFormData(getDebugAfterImageQuestionnaireData());
  };

  return (
    <div className="root-container">
      <div className="app">
        <div className="after-image-questionnaire">
          <h1>Please Rate The Caption</h1>

          {DEBUG_MODE && (
            <Button
              variant="outlined"
              color="warning"
              onClick={fillDebugData}
              sx={{ marginBottom: 2 }}
            >
              🔧 Debug: Fill All Fields
            </Button>
          )}

          <form onSubmit={handleSubmit}>
            <div className="section">
              <h2>How well does the caption describe this image? *</h2>
              <p className="scale-info">
                Choose the option that best matches how accurate, complete, and
                useful the caption is for a travel photobook.
              </p>

              <div
                className="rating-options rating-options--horizontal"
                role="radiogroup"
                aria-label="Caption quality rating"
              >
                {ratingScale.map(({ value, label, description, color }) => {
                  const selected = formData.captionQuality === value;
                  return (
                    <label
                      key={value}
                      className={`rating-card${selected ? " is-selected" : ""}`}
                      data-rating={value}
                      style={{ "--rating-accent": color }}
                    >
                      <input
                        type="radio"
                        name="captionQuality"
                        value={value}
                        checked={selected}
                        onChange={handleChange}
                        required
                      />
                      <span className="rating-card__badge">{value}</span>
                      <span className="rating-card__label">{label}</span>
                      <span className="rating-card__desc">{description}</span>
                    </label>
                  );
                })}
              </div>
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={!formData.captionQuality}
            >
              Submit Rating
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const ratingScale = [
  {
    value: "1",
    label: "Very Poor",
    description:
      "Mostly wrong, or describes a different situation from what is shown.",
    color: "#dc2626",
  },
  {
    value: "2",
    label: "Poor",
    description:
      "Noticeable errors or missing information. Could mislead the photobook reader.",
    color: "#ea580c",
  },
  {
    value: "3",
    label: "Fair",
    description:
      "Captures the basic idea, but incomplete, too general, or missing context.",
    color: "#ca8a04",
  },
  {
    value: "4",
    label: "Good",
    description:
      "Mostly correct and useful, but misses some detail or is a little vague.",
    color: "#65a30d",
  },
  {
    value: "5",
    label: "Excellent",
    description:
      "Main people, objects, scene, and actions are correct. Specific, well located, and useful.",
    color: "#15803d",
  },
];

export default AfterImageQuestionnaire;
